<template>
  <div class="content">
    <div class="b_img"></div>
    <ul v-for="item in dataJson" v-if="item.datas">
      <li>
        <h3 class="title">{{item.name}}</h3>
        <template v-if="item.dataType=='table'" v-for="itemdatas in item.datas">
          <h4 class="subName" v-if="itemdatas.titleName">{{itemdatas.titleName}}</h4>
          <!-- <table>
                  <thead>
                      <tr>
                          <th v-for="th in itemdatas.th">{{th.tableHead}}</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(tdInfo,index) in itemdatas.td">
                          <td v-for="val in tdInfo">{{val}}</td>
                      </tr>
                  </tbody>
              </table> -->
          <el-table :data="itemdatas.td">
            <template v-for="tabledata in itemdatas.tabledata">
              <el-table-column v-if="tabledata.tableHead==='说明'" :prop="tabledata.tdName" :label="tabledata.tableHead"
                                :min-width="250" align="center">
                <template slot-scope="scope">
                  <div v-html="getCustomShowDom(scope, tabledata)"></div>
                </template>
              </el-table-column>
              <el-table-column v-else :prop="tabledata.tdName" :label="tabledata.tableHead" :min-width="tabledata.tableHead=='说明'?250:' '" align="center">
              </el-table-column>
            </template>
          </el-table>
        </template>
        <div v-if="item.dataType==='img'">
          <!--<el-image :src="item.datas"></el-image>-->
          <el-image
            style="width: 100px; height: 100px; cursor: pointer;"
            @click="openViewer"
            :src="item.datas">
          </el-image>
          <el-image-viewer
            v-if="showViewer"
            :on-close="closeViewer"
            :url-list="[item.datas]"
          ></el-image-viewer>
        </div>
        <div v-if="item.dataType=='text'">
          <div v-if="typeof item.datas === 'object' && item.datas.url !== undefined && item.datas.url !== ''">
            {{item.datas.preData}}
            <el-link :underline="underLine" type="primary" :href="item.datas.url">{{item.datas.link}}</el-link>
            {{item.datas.endData}}
          </div>
          <div v-else>{{item.datas}}</div>
        </div>
        <div v-if="item.dataType=='text_debugger'">
          <label style="font-weight: bold">cmd:&nbsp;</label><span>{{getCmd}}</span>
          <br/>
          <label style="font-weight: bold">url: &nbsp;</label>{{item.datas}}
          <a class="linkA" @click="jumpDebugging(item)" href="javascript:;">调试该接口</a>
        </div>
        <div v-if="item.dataType=='code'">
          <slot :name="item.datas">
            只有在没有要分发的内容时才会显示。
          </slot>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";

  export default {
    name: '',
    components: {
      'el-image-viewer': ElImageViewer
    },
    props: {
      'Pdatas': {
        type: Object,
      }
    },
  computed: {
    getCmd: {
      get () {
        let url = this.Pdatas.urlPattern
        return url.substring(url.lastIndexOf('/') + 1)
      },
      set () {

      }
    }
  },
    data() {
      return {
        dataJson: [
          { name: "业务说明", datas: this.Pdatas.explain, dataType: "text" },
          { name: "URL格式", datas: this.Pdatas.urlPattern, dataType: 'text_debugger' },
          { name: "对接流程", datas: this.Pdatas.flow, dataType: "img" },
          //{ name: "生产环境服务地址", datas: this.Pdatas.p_url, dataType: 'text' },
          { name: "前置条件", datas: this.Pdatas.precondition, dataType: 'text' },
          { name: "适用系统", datas: this.Pdatas.fitSystem, dataType: "text" },
          { name: "调用方式", datas: this.Pdatas.pattern, dataType: 'text' },
          { name: "调用频度", datas: this.Pdatas.frequency, dataType: 'text' },
          { name: "请求参数说明", datas: this.Pdatas.Q_params, dataType: 'table' },
          { name: "请求参数示例", datas: 'q_code', dataType: 'code' },
          { name: "响应参数说明", datas: this.Pdatas.R_params, dataType: 'table' },
          { name: "响应参数示例", datas: 'r_code', dataType: 'code' },

        ],
        othersData: [],
        explainWidth: 200,
        underLine: false,
        showViewer: false,
      }
    },

    methods: {
    jumpDebugging(param) {
      console.info("=========="+param.datas);
      let params = {
        url: this.getCmd,
        upward: true,
        body: $("pre")
          .eq(0)
          .html()
      };
      window.localStorage.setItem(
        "DebuggingTools_params",
        JSON.stringify(params)
      );
      window.open("/DebuggingTools");
//       this.$router.push({ name: 'DebuggingTools', params: { url: param.datas, body: $("pre").eq(0).html() }})
    },
      openViewer() {
        let t = this
        this.showViewer = true
        this.$nextTick(() => {
          document.querySelector(".el-image-viewer__mask").onclick = function () {
            t.showViewer = false;
          };
        });
      },

      closeViewer() {
        this.showViewer = false
      },
      getCustomShowDom(scope, tableData) {
        let tdData = scope.row[tableData.tdName]
        if ((!tdData) || tdData.length === 0) {
          return '<label></label>'
        }
        if (tdData.indexOf('<url>') > -1) {
          let startIndex = tdData.indexOf('<url>')
          let firstData = tdData.substring(0, startIndex)
          let endIndex = tdData.indexOf('</url>')
          let link = tdData.substring(startIndex + 5, endIndex)
          let linkArr = link.split(':')
          let lastData = tdData.substring(endIndex + 6)
          return  '<span>' + firstData + '</span>' +
                  '<a class="el-link el-link--primary" type="primary" href="' + linkArr[1] + '">' + linkArr[0] + '</a>' +
                  '<span>' + lastData + '</span>'
        }
        return tdData
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    h3 {
      font-size: 16px;
      margin: 20px 0 10px 0;
    }
    ul {
      padding: 5px 10px;
      li {
        text-align: left;
        a:hover {
          text-decoration: none;
        }
      }
    }
  }

  .subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
  }

  table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
  }

  thead tr:first-child {
    background-color: #f6f8f9;
  }

  table tr:first-child {
    border: none;
  }

  table tr {
    border-top: 1px solid #e7e7eb;
  }

  table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
  }

  table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/components/comUpwardStructure.vue